{
  "id": "crate",
  "name": "Crate",
  "builds": "product",
  "category": "rustic",
  "note": "Leave the gaps between the slats — that's the drainage.",
  "skill": "rusticProjects",
  "duration": 25,
  "offeredBy": "hammer",
  "fastener": "nails",
  "value": 10,
  "widthIn": 36,
  "heightIn": 36,
  "slots": [
    {
      "id": "slat-0",
      "role": "slat",
      "part": {
        "widthIn": 4,
        "lengthIn": 36,
        "thicknessQ": 4
      },
      "stock": {
        "type": "board"
      },
      "xIn": 3,
      "yIn": 18,
      "angleDeg": 0,
      "zIn": 0
    },
    {
      "id": "slat-1",
      "role": "slat",
      "part": {
        "widthIn": 4,
        "lengthIn": 36,
        "thicknessQ": 4
      },
      "stock": {
        "type": "board"
      },
      "xIn": 9,
      "yIn": 18,
      "angleDeg": 0,
      "zIn": 0
    },
    {
      "id": "slat-2",
      "role": "slat",
      "part": {
        "widthIn": 4,
        "lengthIn": 36,
        "thicknessQ": 4
      },
      "stock": {
        "type": "board"
      },
      "xIn": 15,
      "yIn": 18,
      "angleDeg": 0,
      "zIn": 0
    },
    {
      "id": "slat-3",
      "role": "slat",
      "part": {
        "widthIn": 4,
        "lengthIn": 36,
        "thicknessQ": 4
      },
      "stock": {
        "type": "board"
      },
      "xIn": 21,
      "yIn": 18,
      "angleDeg": 0,
      "zIn": 0
    },
    {
      "id": "slat-4",
      "role": "slat",
      "part": {
        "widthIn": 4,
        "lengthIn": 36,
        "thicknessQ": 4
      },
      "stock": {
        "type": "board"
      },
      "xIn": 27,
      "yIn": 18,
      "angleDeg": 0,
      "zIn": 0
    },
    {
      "id": "slat-5",
      "role": "slat",
      "part": {
        "widthIn": 4,
        "lengthIn": 36,
        "thicknessQ": 4
      },
      "stock": {
        "type": "board"
      },
      "xIn": 33,
      "yIn": 18,
      "angleDeg": 0,
      "zIn": 0
    },
    {
      "id": "wall-0",
      "role": "wall",
      "part": {
        "widthIn": 4,
        "lengthIn": 36,
        "thicknessQ": 4
      },
      "stock": {
        "type": "board"
      },
      "xIn": 18,
      "yIn": 2,
      "angleDeg": 90,
      "zIn": 1,
      "onEdge": true
    },
    {
      "id": "wall-1",
      "role": "wall",
      "part": {
        "widthIn": 4,
        "lengthIn": 36,
        "thicknessQ": 4
      },
      "stock": {
        "type": "board"
      },
      "xIn": 18,
      "yIn": 34,
      "angleDeg": 90,
      "zIn": 1,
      "onEdge": true
    },
    {
      "id": "wall-2",
      "role": "wall",
      "part": {
        "widthIn": 4,
        "lengthIn": 36,
        "thicknessQ": 4
      },
      "stock": {
        "type": "board"
      },
      "xIn": 2,
      "yIn": 18,
      "angleDeg": 0,
      "zIn": 5,
      "onEdge": true
    },
    {
      "id": "wall-3",
      "role": "wall",
      "part": {
        "widthIn": 4,
        "lengthIn": 36,
        "thicknessQ": 4
      },
      "stock": {
        "type": "board"
      },
      "xIn": 34,
      "yIn": 18,
      "angleDeg": 0,
      "zIn": 5,
      "onEdge": true
    }
  ],
  "fasteners": [
    {
      "xIn": 3,
      "yIn": 2
    },
    {
      "xIn": 3,
      "yIn": 34
    },
    {
      "xIn": 9,
      "yIn": 2
    },
    {
      "xIn": 9,
      "yIn": 34
    },
    {
      "xIn": 15,
      "yIn": 2
    },
    {
      "xIn": 15,
      "yIn": 34
    },
    {
      "xIn": 21,
      "yIn": 2
    },
    {
      "xIn": 21,
      "yIn": 34
    },
    {
      "xIn": 27,
      "yIn": 2
    },
    {
      "xIn": 27,
      "yIn": 34
    },
    {
      "xIn": 33,
      "yIn": 2
    },
    {
      "xIn": 33,
      "yIn": 34
    },
    {
      "xIn": 2,
      "yIn": 2
    },
    {
      "xIn": 34,
      "yIn": 2
    },
    {
      "xIn": 2,
      "yIn": 34
    },
    {
      "xIn": 34,
      "yIn": 34
    }
  ]
}
